import { AppApiURL } from '@app/app.settings';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CityModel, GenreModel, GenresModel } from '@app/modules/fundamentals-modules/fundamentals.models';
import { HttpRequestToken } from '@app/core/classes';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { StorageService } from '@app/core/services';
import { FundamentalsService } from '@app/modules/fundamentals-modules/fundamentals.service';

@Injectable()

export class GenresService {
  constructor(
    private http: HttpClient,
    private storage: StorageService,
    private fundamentalsService: FundamentalsService
  ) {}

  /**
   * Api: v01.
   * Method: Genres Search
   */
  public genresSearch(searchText: string): Observable<GenresModel> {
    return this.http.get<GenresModel>(AppApiURL + '/genres/search/' + searchText, {
      params: new HttpRequestToken(true)
    }).pipe(
      timeout(10000)
    );
  }

  /**
   * Getting of Genre by dictionary filter.
   * @param genreId
   */
  onGetGenreByDictionary(genreId: number): GenreModel {
    const GenreDictionary = this.fundamentalsService.genresDependencies.filter((item: GenreModel) => {
      return item.id === genreId;
    });

    return GenreDictionary.length ? GenreDictionary[0] : null;
  }

  /**
   * Getting of default Genre.
   */
  onGetGenreDefault(): CityModel {
    return this.fundamentalsService.genresRecommendations[0];
  }
}
